export default {
  dynamics: '{{change}} față de săptămâna anterioară',
};
